// /* 
// 	CatalogBookCard component is used to show the listing of the books
// 	This component accepts following proptypes.
// 	@param Books - Books list
// 	@param AffiliateCode - Amazon Preview_Link_Affiliate_Code
//     @param SiteId - siteId
//     @param ShowContributor -  true/false
//     @param TotalBooks - Total number of books available
//     @param RenderSchema - true/false
//     @param host - Domain name 
// */

import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import {
    BuildServerlessBookCoverImageUrl,
    formatBookDetailUrl,
    RenderBookSchema,
} from 'helpers/Helper';
import IMAGESIZES from 'src/constants/IMAGESIZES';

import styles from "./CatalogBookCard.module.css";

import AmazonPreviewLink from '@components/AmazonPreviewLink/AmazonPreviewLink';
import ShowContributors from '@components/ShowContributor';
import NextImage from '@components/Image/NextImage';
import NewsletterBanner from '@components/NewsletterBanner/NewsletterBanner';

export const CatalogBookCard = (props) => {
    let { subscriberCookie, host, 
        ShowContributor = true, 
        ShowFollowAuthor = true,
        ShouldLazyLoadCount = 4,
        ShowAmazonPreviewLink = true } = props;

    return props.Books && props.Books.map((item, index) => {
        let bookUrl = formatBookDetailUrl(item.primary_isbn, item.title);
        let shouldLazyLoad = index < ShouldLazyLoadCount ? false : true;
        let bookCoverUrl = BuildServerlessBookCoverImageUrl(IMAGESIZES.BC_CATALOGBOOKCARD, item.image)

        return (
            <React.Fragment key={item.primary_isbn || item._id || index}>
                <div className={styles.card}>
                    <div className={styles.cardImage} key={'book-list-image-' + index}>
                        <Link href={bookUrl}>
                            <NextImage
                                ImageUrl={bookCoverUrl}
                                Title={item.title}
                                Alt_Text={item.title}
                                className='catelog-card-img-top'
                                Layout='responsive'
                                isLazyload={shouldLazyLoad}
                                width={300}
                                height={0}
                            />
                        </Link>
                        {ShowAmazonPreviewLink === true ?
                            <AmazonPreviewLink className='center bookCard' asin={item.asin ? item.asin : ''} affiliateCode={props.AffiliateCode ? props.AffiliateCode : ''} />
                            : ''}
                    </div>
                    <div className={styles.cardBody}>
                        <h4 className={styles.cardTitle} title={item.title}>
                            <Link href={bookUrl}>
                                <span dangerouslySetInnerHTML={{ __html: item.title }} />
                            </Link>
                        </h4>

                        {props.ShowContributor === true ?
                            <ShowContributors
                                Book={item}
                                SiteId={props.SiteId}
                                Class='book-card'
                                ShowFollowAuthor={ShowFollowAuthor}
                                RenderShowMoreAuthor={true}
                                EventName={props.EventName}
                                HideAuthorAfterTwo={true}
                                IsLazyLoadFollowIcon={shouldLazyLoad}
                            />
                            : ''}
                    </div>
                </div>
                {(props.TotalBooks >= 8) ? index == 7 && !subscriberCookie && <NewsletterBanner /> : (index == props.TotalBooks - 1) && !subscriberCookie && <NewsletterBanner />}
                {props.RenderSchema === true ?
                    <script
                        type="application/ld+json"
                        dangerouslySetInnerHTML={RenderBookSchema(item, `${props.host}${bookUrl}`, host)}
                    /> : ''}

            </React.Fragment>
        );
    });
}

CatalogBookCard.propTypes = {
    Books: PropTypes.array.isRequired,
    AffiliateCode: PropTypes.string.isRequired,
    SiteId: PropTypes.number.isRequired,
    ShowContributor: PropTypes.bool.isRequired,
    TotalBooks: PropTypes.number.isRequired,
    RenderSchema: PropTypes.bool.isRequired,
    host: PropTypes.string.isRequired,
    ShowFollowAuthor: PropTypes.bool,
    EventName: PropTypes.string,
    ShouldLazyLoadCount: PropTypes.number,
    ShowAmazonPreviewLink: PropTypes.bool
}

export default CatalogBookCard;
